import { render } from "./category-settings.vue?vue&type=template&id=28f971c7"
import script from "./category-settings.vue?vue&type=script&lang=js"
export * from "./category-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__